import { render, staticRenderFns } from "./ActiveColumn.vue?vue&type=template&id=037e4157&scoped=true&"
import script from "./ActiveColumn.vue?vue&type=script&lang=js&"
export * from "./ActiveColumn.vue?vue&type=script&lang=js&"
import style0 from "./ActiveColumn.vue?vue&type=style&index=0&id=037e4157&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037e4157",
  null
  
)

export default component.exports